import { useNavigate } from 'react-router-dom';
import CheckIcon from '@mui/icons-material/Check';

import { Section, ContentContainer } from '../../styles';
import {
  PricingHeading,
  PricingSubtext,
  PricingContentWrapper,
  PricingGridContainer,
  PricingCardsContainer,
  PricingCardHeader,
  PricingCard,
  PricingCheckIcon,
  PricingCardTextWrapper,
  PricingCardText,
  PricingImageGrid,
  PricingImageWrapper,
  PricingImage,
} from './styles';
import { practitionerfaq } from '../../constants';
import CTAButton from '../../../../../ui/ctaButton';
import NirvaPractitionerImage from '../../../../../assets/images/NirvaPractitioner.webp';

const PricingSection = () => {
  const navigate = useNavigate();
  const handleExploreServicesClick = () => {
    navigate('/services');
  };
  return (
    <Section>
      <ContentContainer>
        <PricingHeading>How Much Does It Cost to Work with a Nirva Practitioner?</PricingHeading>

        <PricingSubtext>
          At Nirva, we believe clarity is part of care. Our pricing is transparent, competitive, and
          designed to be accessible—so you always know what to expect.
        </PricingSubtext>

        <PricingContentWrapper>
          <PricingGridContainer container spacing={{ xs: 3, md: 3 }}>
            <PricingCardsContainer>
              <PricingCardHeader>What you can expect from Nirva pricing:</PricingCardHeader>
              {practitionerfaq.map((step, index) => (
                <PricingCard key={index}>
                  <PricingCheckIcon>
                    <CheckIcon />
                  </PricingCheckIcon>
                  <PricingCardTextWrapper>
                    <PricingCardText>{step.title}</PricingCardText>
                  </PricingCardTextWrapper>
                </PricingCard>
              ))}
            </PricingCardsContainer>

            <PricingImageGrid item xs={12} md={12} lg={6}>
              <PricingImageWrapper>
                <PricingImage src={NirvaPractitionerImage} alt="Hypnotherapy Session" />
              </PricingImageWrapper>
            </PricingImageGrid>
          </PricingGridContainer>
        </PricingContentWrapper>

        <CTAButton
          variant="contained"
          text="Explore Our Services"
          onClick={handleExploreServicesClick}
        />
      </ContentContainer>
    </Section>
  );
};

export default PricingSection;
